import React from 'react';
import ReactDOM from 'react-dom';
import './HoverableDescriptionBox.css';

class HoverableDescriptionBox extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isHovering: false,
            tooltipStyle: {}
        };
        
        this.boxRef = React.createRef();
        this.tooltipElement = null;
        
        this.handleMouseOver = this.handleMouseOver.bind(this);
        this.handleMouseOut = this.handleMouseOut.bind(this);
    }
    
    componentDidMount() {
        this.tooltipElement = document.createElement('div');
    }
    
    componentWillUnmount() {
        this.removeTooltipFromDOM();
    }
    
    removeTooltipFromDOM() {
        if (this.tooltipElement && this.tooltipElement.parentNode) {
            this.tooltipElement.parentNode.removeChild(this.tooltipElement);
        }
        this.tooltipElement = null;
    }
    
    handleMouseOver() {
        if (!this.boxRef.current) return;
        
        const rect = this.boxRef.current.getBoundingClientRect();

        const tooltipStyle = {
            position: 'fixed',
            left: rect.left + rect.width / 2,
            transform: 'translateX(-50%)',
            top: rect.bottom + 5,
        };
        
        this.setState({ 
            isHovering: true,
            tooltipStyle
        });
        
        // Ensure the tooltip element is in the DOM
        if (this.tooltipElement && !this.tooltipElement.parentNode) {
            document.body.appendChild(this.tooltipElement);
        }
    }
    
    handleMouseOut() {
        this.setState({ isHovering: false });
    }
    
    renderTooltip() {
        if (!this.state.isHovering || !this.tooltipElement) return null;
        
        const { tooltipStyle } = this.state;
        const description = this.props.description || '';
        
        return ReactDOM.createPortal(
            <div 
                className={"hoverable-tooltip"}
                style={tooltipStyle}
            >
                {description}
            </div>,
            this.tooltipElement
        );
    }

    render() {
        const header = this.props.header || '';
        
        return (
            <div 
                ref={this.boxRef}
                className="hoverable-box"
                onMouseOver={this.handleMouseOver}
                onMouseOut={this.handleMouseOut}
            >
                <span className="hoverable-header">{header}</span>
                {this.renderTooltip()}
            </div>
        );
    }
}

export default HoverableDescriptionBox;
